import { getAxiosInstance } from "../../../redux/common";

export const getAllCalibrations = async (queryParams) => {
  return await getAxiosInstance().get("/api/calibration/filter", {
    params: queryParams,
  });
};

export const getFliteredCalibrations = async (queryParams) => {
  return await getAxiosInstance().get("/api/calibration/filter", {
    params: queryParams,
  });
};

export const removeCalibrationById = async (deviceId) => {
  return await getAxiosInstance().delete("/api/calibration/" + deviceId);
};

export const getBaseAveragedCalibrations = async () => {
  return await getAxiosInstance().get("/api/calibration/averaged/base");
};

export const getManufacturerAveragedCalibrations = async () => {
  return await getAxiosInstance().get("/api/calibration/averaged/manufacturer");
};

export const getBrandAveragedCalibrations = async () => {
  return await getAxiosInstance().get("/api/calibration/averaged/brand");
};

export const getModelAveragedCalibrations = async () => {
  return await getAxiosInstance().get("/api/calibration/averaged/model");
};

export const getAveragedById = async (id) => {
  return await getAxiosInstance().get("/api/calibration/averaged/" + id);
};

export const includeCheckBox = async (id) => {
  return await getAxiosInstance().post("/api/calibration/averaged/include", {
    id: id,
  });
};

export const excludeCheckBox = async (id) => {
  return await getAxiosInstance().post("/api/calibration/averaged/exclude", {
    id: id,
  });
};

export const removeAveragedCalibrationById = async (id) => {
  return await getAxiosInstance().delete("/api/calibration/averaged/" + id);
};
